import EXIF from 'exif-js';
import config from '../config/config';


export class ImageProcess {

    /**
     * Rotate in 90°
     * @param imageBase64 image to rotate
     * @returns {Promise<any>}
     */
    rotateImage = (imageBase64) => {
        let img = document.createElement('img');
        img.src = imageBase64;
        const result = new Promise((resolve, reject) => {
            img.onload = async () => {
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');

                const imageWidth = img.width;
                const imageHeight = img.height;

                var angle = (Math.PI / 180) * 90;

                canvas.width = imageHeight;
                canvas.height = imageWidth;
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                ctx.translate(Math.abs(imageWidth/2 * Math.cos(angle) + imageHeight/2 * Math.sin(angle)), Math.abs(imageHeight/2 * Math.cos(angle) + imageWidth/2 * Math.sin(angle)));
                ctx.rotate(angle);
                ctx.translate(-imageWidth/2, -imageHeight/2);
                ctx.drawImage(img, 0, 0, imageWidth,imageHeight);

                const resultRotation = canvas.toDataURL();
                resolve(resultRotation);
            };
            img.onError = () => {
                reject('Error to resize image')
            };
        });
        return result;
    };


    /**
     * Get image from fileInput
     * @param event
     * @param fileInput
     */
    getImageFromFileInput = (event, fileInput) => {
        const result = new Promise((resolve, reject) => {
            if (fileInput.files.length > 0) {
                const file = fileInput.files[0];
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = async () => {
                    const imageBase64Format = reader.result;
                    const optimizedImage = await this.resizeImage(
                        imageBase64Format,
                        parseInt(config.resize_image_width, 10),
                        parseInt(config.resize_image_height, 10)
                    );
                    resolve(optimizedImage);
                };
                reader.onerror = (error) => {
                    reject(`Error to get image from fileInput, ${error}`);
                };
            } else {
                reject('fileInput is empty');
            }
        });
        return result;
    };


    getOrientation = (img) => {
        let orientation = new Promise((resolve, reject) => {
            EXIF.getData(img, function () {                
                resolve(EXIF.getTag(this, "Orientation"));
            });
        });
        return orientation;
    };

    setOrientation = (ctx, orientation, width, height) => {
        switch (orientation) {
            case 2:
                ctx.transform(-1, 0, 0, 1, width, 0);
                break;
            case 3:
                ctx.transform(-1, 0, 0, -1, width, height);
                break;
            case 4:
                ctx.transform(1, 0, 0, -1, 0, height);
                break;
            case 5:
                ctx.transform(0, 1, 1, 0, 0, 0);
                break;
            case 6:
                ctx.transform(0, 1, -1, 0, height, 0);
                break;
            case 7:
                ctx.transform(0, -1, -1, 0, height, width);
                break;
            case 8:
                ctx.transform(0, -1, 1, 0, 0, width);
                break;
            default:
                break;
        }
    };

    /**
     * resize base64 image
     * @param base64Image image to resize
     * @param maxWidth max width (maintain aspect ratio)
     * @param maxHeight max height (maintain aspect ratio)
     * @returns {Promise<any>} image with new sizes in base64
     */
    resizeImage = (base64Image, maxWidth, maxHeight) => {
        if (config.resize_image === false) {
            return base64Image;
        }
        let img = document.createElement('img');
        img.src = base64Image;
        const result = new Promise((resolve, reject) => {
            img.onload = async () => {
                let orientation = await this.getOrientation(img);
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                const imageWidth = img.width;
                const imageHeight = img.height;

                let auxWidth = imageWidth;
                let auxHeight = imageHeight;

                const positionsToRotate = [6, 8, 5, 7];

                //change size to set canvas
                if (positionsToRotate.includes(orientation)) {
                    const auxSize = auxHeight;
                    auxHeight = auxWidth;
                    auxWidth = auxSize;
                }

                //set image size
                if (auxWidth > auxHeight && auxWidth > maxWidth) {
                    auxHeight *= maxWidth / auxWidth;
                    auxWidth = maxWidth;
                } else if (auxHeight > maxHeight) {
                    auxWidth *= maxHeight / auxHeight;
                    auxHeight = maxHeight;
                }

                canvas.height = auxHeight;
                canvas.width = auxWidth;

                //change size to rotation
                if (positionsToRotate.includes(orientation)) {
                    const auxSize = auxHeight;
                    auxHeight = auxWidth;
                    auxWidth = auxSize;
                    this.setOrientation(ctx, orientation, auxWidth, auxHeight);
                }

                ctx.drawImage(img, 0, 0, auxWidth, auxHeight);

                const result = canvas.toDataURL();
                resolve(result);
            };
            img.onError = () => {
                reject('Error to resize image')
            };
        });
        return result;
    };
}

export default new

ImageProcess();